@if (user && travelPreferencesForm) {
  <div [formGroup]="travelPreferencesForm">
    <div formArrayName="preferences" class="profile_information--content">
      <div class="profile_information--sub-header" i18n="@@ProfileInformation-Air">Air</div>
      @for (preferenceForm of preferences.controls; track preferenceForm; let i = $index) {
        <div [formGroupName]="i">
          @if (
            preferenceForm.get('preferenceKey').value ===
            preferenceKeyEnum.FlightNotificationsEnabled
          ) {
            <div class="profile_information--input-container">
              <div class="profile_information--input-label">
                <span i18n="@@ProfileInformation-FlightNotificationsEnabled"
                  >Flight Notifications</span
                >:
              </div>
              <div class="profile_information--input-wrapper">
                <select class="profile_information--input" formControlName="preferenceValue">
                  <option value="" i18n="@@ProfileInformation-None">None</option>
                  @for (flightNotification of flightNotifications; track flightNotification) {
                    <option [value]="flightNotification.label">
                      {{ flightNotification.label | translate }}
                    </option>
                  }
                </select>
                <fa-icon [icon]="faChevronDown"></fa-icon>
              </div>
            </div>
          }
          @if (preferenceForm.get('preferenceKey').value === preferenceKeyEnum.SpecialNeed) {
            <div class="profile_information--input-container">
              <div class="profile_information--input-label">
                <span i18n="@@ProfileInformation-SpecialNeed">Special Need</span>:
              </div>
              <div class="profile_information--input-wrapper">
                <select class="profile_information--input" formControlName="preferenceValue">
                  <option value="" i18n="@@ProfileInformation-None">None</option>
                  @for (special of specialNeed; track special) {
                    <option [value]="special.label">
                      {{ special.label | translate }}
                    </option>
                  }
                </select>
                <fa-icon [icon]="faChevronDown"></fa-icon>
              </div>
            </div>
          }
          @if (preferenceForm.get('preferenceKey').value === preferenceKeyEnum.MealRequest) {
            <div class="profile_information--input-container">
              <div class="profile_information--input-label">
                <span i18n="@@ProfileInformation-MealRequests">Meal Requests</span>:
              </div>
              <div class="profile_information--input-wrapper">
                <select class="profile_information--input" formControlName="preferenceValue">
                  <option value="" i18n="@@ProfileInformation-None">None</option>
                  @for (meal of mealRequest; track meal) {
                    <option [value]="meal.label">
                      {{ meal.label | translate }}
                    </option>
                  }
                </select>
                <fa-icon [icon]="faChevronDown"></fa-icon>
              </div>
            </div>
          }
          @if (preferenceForm.get('preferenceKey').value === preferenceKeyEnum.SeatingPreference) {
            <div class="profile_information--input-container">
              <div class="profile_information--input-label">
                <span i18n="@@ProfileInformation-SeatingPreference">Seating Preference</span>:
              </div>
              <div class="profile_information--input-wrapper">
                <select class="profile_information--input" formControlName="preferenceValue">
                  <option value="" i18n="@@ProfileInformation-None">None</option>
                  @for (seat of seatingPreference; track seat) {
                    <option [value]="seat.label">
                      {{ seat.label | translate }}
                    </option>
                  }
                </select>
                <fa-icon [icon]="faChevronDown"></fa-icon>
              </div>
            </div>
          }
        </div>
      }
      <div class="profile_information--sub-header" i18n="@@ProfileInformation-Rail">Rail</div>
      @for (preferenceForm of preferences.controls; track preferenceForm; let i = $index) {
        <div [formGroupName]="i">
          @if (preferenceForm.get('preferenceKey').value === preferenceKeyEnum.SeatDirection) {
            <div class="profile_information--input-container">
              <div class="profile_information--input-label">
                <span i18n="@@ProfileInformation-SeatDirection">Seat Direction</span>:
              </div>
              <div class="profile_information--input-wrapper">
                <select class="profile_information--input" formControlName="preferenceValue">
                  <option value="" i18n="@@ProfileInformation-None">None</option>
                  @for (seat of seatDirection; track seat) {
                    <option [value]="seat.label">
                      {{ seat.label | translate }}
                    </option>
                  }
                </select>
                <fa-icon [icon]="faChevronDown"></fa-icon>
              </div>
            </div>
          }
          @if (preferenceForm.get('preferenceKey').value === preferenceKeyEnum.SeatPosition) {
            <div class="profile_information--input-container">
              <div class="profile_information--input-label">
                <span i18n="@@ProfileInformation-SeatPosition">Seat Position</span>:
              </div>
              <div class="profile_information--input-wrapper">
                <select class="profile_information--input" formControlName="preferenceValue">
                  <option value="" i18n="@@ProfileInformation-None">None</option>
                  @for (seat of seatPosition; track seat) {
                    <option [value]="seat.label">
                      {{ seat.label | translate }}
                    </option>
                  }
                </select>
                <fa-icon [icon]="faChevronDown"></fa-icon>
              </div>
            </div>
          }
          @if (preferenceForm.get('preferenceKey').value === preferenceKeyEnum.SeatLocation) {
            <div class="profile_information--input-container">
              <div class="profile_information--input-label">
                <span i18n="@@ProfileInformation-SeatLocation">Seat Location</span>:
              </div>
              <div class="profile_information--input-wrapper">
                <select class="profile_information--input" formControlName="preferenceValue">
                  <option value="" i18n="@@ProfileInformation-None">None</option>
                  @for (seat of seatLocation; track seat) {
                    <option [value]="seat.label">
                      {{ seat.label | translate }}
                    </option>
                  }
                </select>
                <fa-icon [icon]="faChevronDown"></fa-icon>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
